import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CurrencyContext = createContext(null);

const SYMBOLS = {
  usd: "$", eur: "€", gbp: "£", inr: "₹", jpy: "¥",
  aud: "A$", cad: "C$", sgd: "S$", brl: "R$", aed: "د.إ",
  chf: "CHF", mxn: "MX$", zar: "R", hkd: "HK$",
};

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrency] = useState(() => localStorage.getItem("cv_currency") || "usd");
  const [rates, setRates] = useState({ usd: 1 });
  const [lastUpdated, setLastUpdated] = useState(null);

  useEffect(() => {
    api.get("/currencies").then((r) => {
      const map = {};
      (r.data.rates || []).forEach((c) => { map[c.code] = c.rate_vs_usd; });
      setRates(map);
      setLastUpdated(r.data.last_updated);
    });
  }, []);

  const change = (c) => {
    setCurrency(c);
    localStorage.setItem("cv_currency", c);
  };

  const format = (usdAmount) => {
    const rate = rates[currency] || 1;
    const value = usdAmount * rate;
    const symbol = SYMBOLS[currency] || "$";
    const decimals = currency === "jpy" ? 0 : 2;
    return `${symbol}${value.toLocaleString(undefined, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
  };

  return (
    <CurrencyContext.Provider value={{ currency, setCurrency: change, rates, lastUpdated, format, symbols: SYMBOLS }}>
      {children}
    </CurrencyContext.Provider>
  );
};

export const useCurrency = () => useContext(CurrencyContext);
